// import { find, assign } from 'lodash'
export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      tools = _ref.tools;
  return {
    loadOrderInfo: function loadOrderInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/order/orderInfo',
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
      });
    },
    loadRateList: function loadRateList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/rate/list',
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
      });
    },
    saveRate: function saveRate(data) {
      return request({
        url: '/rate/save',
        method: 'post',
        data: data
      });
    }
  };
});